import { IResourceComponentsProps, useNavigation, useParsed } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, message } from 'antd';
import { DocumentEditor } from './DocumentEditor';

export const DocumentEdit: React.FC<IResourceComponentsProps> = () => {
  const { id } = useParsed();
  const { formProps, saveButtonProps } = useForm({
    id,
    meta: {
      method: "patch",
    },
    onMutationSuccess: () => {
      message.success('Document updated successfully');
    },
    onMutationError: () => {
      message.error('Failed to update document');
    },
    redirect: "show"
  });

  return (
    <Edit
      saveButtonProps={{
        hidden: true,
      }}
      deleteButtonProps={{
        hidden: true,
      }}
      headerProps={{
        title: "Edit Document",
      }}
      headerButtons={<></>}
      breadcrumb={false}
      canDelete={true}>
      <Form {...formProps} layout="vertical">
        <DocumentEditor title='' content='' actionButtonProps={saveButtonProps} />
      </Form>
    </Edit>
  );
};
